var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFillin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 14.0002L14.9999 14.8207C14.6021 15.2558 14.0626 15.5002 13.5001 15.5002C12.9376 15.5002 12.3981 15.2558 12.0003 14.8207C11.6019 14.3865 11.0625 14.1427 10.5001 14.1427C9.93778 14.1427 9.39835 14.3865 8.99998 14.8207M2.25 15.5002H3.50591C3.87279 15.5002 4.05624 15.5002 4.22887 15.4587C4.38192 15.422 4.52824 15.3614 4.66245 15.2791C4.81382 15.1864 4.94354 15.0567 5.20296 14.7972L14.625 5.37517C15.2463 4.75385 15.2463 3.74649 14.625 3.12517C14.0037 2.50385 12.9963 2.50385 12.375 3.12517L2.95295 12.5472C2.69352 12.8067 2.5638 12.9364 2.47104 13.0877C2.3888 13.222 2.32819 13.3683 2.29145 13.5213C2.25 13.694 2.25 13.8774 2.25 14.2443V15.5002Z",
    stroke: "#0E0E0E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 14.0002L14.9999 14.8207C14.6021 15.2558 14.0626 15.5002 13.5001 15.5002C12.9376 15.5002 12.3981 15.2558 12.0003 14.8207C11.6019 14.3865 11.0625 14.1427 10.5001 14.1427C9.93778 14.1427 9.39835 14.3865 8.99998 14.8207M2.25 15.5002H3.50591C3.87279 15.5002 4.05624 15.5002 4.22887 15.4587C4.38192 15.422 4.52824 15.3614 4.66245 15.2791C4.81382 15.1864 4.94354 15.0567 5.20296 14.7972L14.625 5.37517C15.2463 4.75385 15.2463 3.74649 14.625 3.12517C14.0037 2.50385 12.9963 2.50385 12.375 3.12517L2.95295 12.5472C2.69352 12.8067 2.5638 12.9364 2.47104 13.0877C2.3888 13.222 2.32819 13.3683 2.29145 13.5213C2.25 13.694 2.25 13.8774 2.25 14.2443V15.5002Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 14.0002L14.9999 14.8207C14.6021 15.2558 14.0626 15.5002 13.5001 15.5002C12.9376 15.5002 12.3981 15.2558 12.0003 14.8207C11.6019 14.3865 11.0625 14.1427 10.5001 14.1427C9.93778 14.1427 9.39835 14.3865 8.99998 14.8207M2.25 15.5002H3.50591C3.87279 15.5002 4.05624 15.5002 4.22887 15.4587C4.38192 15.422 4.52824 15.3614 4.66245 15.2791C4.81382 15.1864 4.94354 15.0567 5.20296 14.7972L14.625 5.37517C15.2463 4.75385 15.2463 3.74649 14.625 3.12517C14.0037 2.50385 12.9963 2.50385 12.375 3.12517L2.95295 12.5472C2.69352 12.8067 2.5638 12.9364 2.47104 13.0877C2.3888 13.222 2.32819 13.3683 2.29145 13.5213C2.25 13.694 2.25 13.8774 2.25 14.2443V15.5002Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillin);
export default __webpack_public_path__ + "static/media/fillin.822dc792d9287fd21c516863e83bde46.svg";
export { ForwardRef as ReactComponent };